import React from "react";
import { SectionLabel, Reveal, SunRays } from "@/lib/uiHelpers";
import { ABOUT_BADGES } from "@/constants/landingCopy";
import { Palmtree, Zap, ShieldCheck, RadioTower, Star, Wrench, BatteryCharging } from "lucide-react";

const ICONS = {
  island: Palmtree,
  bolt: Zap,
  shield: ShieldCheck,
  signal: RadioTower,
  star: Star,
  wrench: Wrench,
  battery: BatteryCharging,
};

function TrustBadge({ badge }) {
  const Icon = ICONS[badge.icon] || Star;
  return (
    <div
      className="flex items-center gap-3 rounded-xl px-4 py-4"
      style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)" }}
    >
      <span
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg"
        style={{ background: "rgba(245,166,35,0.16)" }}
      >
        <Icon size={20} style={{ color: "#F5A623" }} />
      </span>
      <span className="font-head font-semibold text-sm text-white">{badge.label}</span>
    </div>
  );
}

function AboutCopy() {
  return (
    <Reveal>
      <SectionLabel>Who We Are</SectionLabel>
      <h2 className="font-head font-extrabold text-3xl md:text-5xl text-white leading-tight">
        Maui-Born. Maui-Built.
        <span className="block" style={{ color: "#F5A623" }}>We Know This Island.</span>
      </h2>
      <div className="mt-6 space-y-4 font-body text-white/80 text-base md:text-lg">
        <p>
          We&apos;re not a mainland company dropping in. We&apos;re Maui-based solar and electrical
          contractors who know HECO, know Maui County permitting, and know what it takes to get a
          system installed and live on an island where everything takes longer and costs more.
        </p>
        <p>
          Our crews are local. Our licenses are current. Our mission is simple: help Maui families
          stop overpaying for electricity.
        </p>
        <p>
          From your first call to your final inspection, we handle everything &mdash; so you
          don&apos;t have to.
        </p>
      </div>
    </Reveal>
  );
}

export default function AboutUs() {
  return (
    <section className="section-pad relative overflow-hidden" style={{ backgroundColor: "#1A2B4A" }}>
      <SunRays color="#F5A623" opacity={0.1} originX="100%" originY="100%" />
      <div className="container-max relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <AboutCopy />
          <Reveal delay={0.12}>
            <div className="grid sm:grid-cols-2 gap-4">
              {ABOUT_BADGES.map((b) => (
                <TrustBadge key={b.label} badge={b} />
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
